// extracted by mini-css-extract-plugin
export var columnList = "_e3-0";